import { z } from 'zod';

type RefinementCtx = z.RefinementCtx;

export function addCustomIssue(ctx: RefinementCtx, path: (string | number)[], message: string) {
  ctx.addIssue({ code: 'custom', path, message });
}

export function validateInviteAsUserFields(
  data: { firstName?: string; lastName?: string; email?: string | null },
  ctx: RefinementCtx,
) {
  if (!data.firstName?.trim()) {
    addCustomIssue(ctx, ['firstName'], 'Provide first name');
  }
  if (!data.lastName?.trim()) {
    addCustomIssue(ctx, ['lastName'], 'Provide last name');
  }
  if (!data.email?.trim()) {
    addCustomIssue(ctx, ['email'], 'Provide email');
  }
}
